module.exports = __webpack_public_path__ + "static/media/news_opt.c1a3177c.jpg";